import { mapState, mapActions } from 'vuex'
import PaymentGroupOrders from '@/pages/collect-orders/components/payment-group-orders/payment-group-orders.vue'
import MarkerOrderDishes from '../marker-order-dishes/marker-order-dishes.vue'
import NotAcceptedOrdersModal from '@/components/modals/not-accepted-orders-modal/not-accepted-orders-modal.vue'
import SendInProgressOrdersModal from '@/components/modals/send-in-progress-orders-modal/send-in-progress-orders-modal.vue'
import CourierDetailModal from '@/components/modals/courier-detail-modal/courier-detail-modal.vue'
import { getShortId } from '@/utils/format-strings'
import { getRequestId } from '@/services/ws'
import copyTextMixin from '@/components/mixins/copy-text-mixin'

export default {
  name: 'AcceptRouteTask',
  /**   * 
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
  mixins: [copyTextMixin],
  props: {
    type: {
      type: String,
      default: 'accepted' // not_accepted | remaking
    },
    routeTaskData: {
      type: Object,
      required: true
    }
  },
  components: {
    MarkerOrderDishes,
    PaymentGroupOrders,
    NotAcceptedOrdersModal,
    SendInProgressOrdersModal,
    CourierDetailModal
  },
  data() {
    return {
      showGroups: false,
      ordersToRemake: []
    }
  },

  computed: {

    ...mapState({
      acceptSocket: state => state.collectOrders.acceptSocket,
      remakeSocket: state => state.collectOrders.remakeSocket
    }),

    fullView() {
      return this.showGroups || this.type === 'remaking'
    },

    statusText() {
      // Завершен | Не принято | В доготовке | Готово
      if (this.type === 'accepted' && !this.routeTaskData.forced_finish) {
        return 'Завершен'
      }
      if (this.type === 'accepted' && this.routeTaskData.forced_finish) {
        return 'Отменен'
      }
      if (this.type === 'not_accepted') {
        return 'Не принято'
      }

      if (this.type === 'remaking' && this.routeTaskData.status === 'in_progress') {
        return 'В доготовке'
      }

      if (this.type === 'remaking' && this.routeTaskData.status === 'done') {
        return 'Готово'
      }
    }
  },
  methods: {
    ...mapActions({
      getOrdersToRemake: 'collectOrders/getOrdersToRemake'
    }),

    getShortId,

    async onApplyDiscard(event) {
      const sendedObj = {
        request_id: getRequestId(event.routeTask.id, 'discard'),
        id: event.routeTask.id,
        action: 'discard',
        text: event.sendData.comment
      }
      await this.acceptSocket.sendPromise(sendedObj)
      
    },

    async acceptRouteTask() {
      const sendedObj = {
        request_id: getRequestId(this.routeTaskData.id, 'accepted'),
        id: this.routeTaskData.id,
        action: 'accepted'
      }
      await this.acceptSocket.sendPromise(sendedObj)
    },

    async onRouteTaskCollected() {
      const sendedObj = {
        request_id: getRequestId(this.routeTaskData.id, 'route_task_collected'),
        id: this.routeTaskData.id,
        action: 'route_task_collected'
      }
      await this.remakeSocket.sendPromise(sendedObj)
    },

    async showSendInProgressOrdersModal() {
      const data = await this.getOrdersToRemake(this.routeTaskData.id)
      this.ordersToRemake = data
      this.$nextTick(() => {
        this.$refs['send-in-progress-orders-modal'].show()
      })
    },

    async onSendToRemake(event) {
      const sendedObj = {
        route_task_id: this.routeTaskData.id,
        action: 'remaking',
        order_item_ids: event,
        request_id: getRequestId(this.routeTaskData.id, 'remaking')
      }
      await this.remakeSocket.sendPromise(sendedObj)
    }
  }
}
